// Synthesized notification sounds via the Web Audio API — no bundled audio
// assets. A shared AudioContext is created lazily and resumed within a user
// gesture (browsers block audio otherwise).
let ctx = null;

function audioCtx() {
  if (!ctx) {
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return null;
    ctx = new AC();
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

// Call from a click handler (toggle / Run) so the context is allowed to start.
export function primeAudio() {
  audioCtx();
}

// One enveloped tone: quick attack, exponential decay to silence.
function tone(ac, freq, start, dur, type, gain) {
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, start);
  g.gain.linearRampToValueAtTime(gain, start + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, start + dur);
  osc.connect(g).connect(ac.destination);
  osc.start(start);
  osc.stop(start + dur + 0.02);
}

// Pleasant ascending major arpeggio (C5–E5–G5).
export function playSuccess() {
  const ac = audioCtx();
  if (!ac) return;
  const t = ac.currentTime;
  tone(ac, 523.25, t,        0.18, 'sine', 0.18);
  tone(ac, 659.25, t + 0.11, 0.18, 'sine', 0.18);
  tone(ac, 783.99, t + 0.22, 0.30, 'sine', 0.20);
}

// Low, dissonant descending buzz.
export function playError() {
  const ac = audioCtx();
  if (!ac) return;
  const t = ac.currentTime;
  tone(ac, 311.13, t,        0.24, 'sawtooth', 0.14);
  tone(ac, 220.00, t + 0.17, 0.38, 'sawtooth', 0.14);
}
